import React from 'react';
import { Property } from '@/types/property';
import { MapPin } from 'lucide-react';

interface PropertyMapProps {
  loading: boolean;
  dataLoaded: boolean;
  databaseError: string | null;
  properties: Property[];
  dashboardType?: 'venda' | 'aluguel' | 'sairam-ultima-semana' | 'entraram-ultima-semana';
}

const PropertyMap: React.FC<PropertyMapProps> = ({ properties }) => {
  return (
    <div className="h-full flex flex-col items-center justify-center">
      <MapPin className="h-16 w-16 text-muted-foreground mb-4" />
      <p className="text-muted-foreground text-center">
        Visualizando {properties.length.toLocaleString('pt-BR')} imóveis no mapa.
        <br />
        O mapa interativo será implementado em uma versão futura com a API do Google Maps.
      </p>
    </div>
  );
};

export default PropertyMap;
